import stylesheet0 from "@oneappexchange/appx-font-utilities";

function stylesheet(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  var suffixToken = token ? ("-" + token) : "";
  return ".labeled-value" + shadowSelector + " {margin: 0;}.labeled-value__group" + shadowSelector + " {display: flex;flex-direction: column;gap: var(--sds-g-spacing-1);}.labeled-value__title" + shadowSelector + " {display: flex;align-items: center;margin: 0;}.labeled-value__title-text" + shadowSelector + " {font-weight: var(--sds-g-font-weight-bold, bold);}.labeled-value__content" + shadowSelector + " {margin-inline-start: 0;}";
  /*LWC compiler v7.1.3*/
}
export default [stylesheet0, stylesheet];